export const IMAGE_EXTENSIONS = [".jpeg", ".jpg", ".png"];
export const PDF_EXTENSIONS = [".pdf"];
export const TEXT_EXTENSIONS = [".txt"];
export const WORD_EXTENSIONS = [".doc", ".docx"];
export const EXCEL_EXTENSIONS = [".xls", ".xlsx"];
export const OPEN_OFFICE__EXTENSIONS = [".odt", ".ods"];

export const FILE_EXTENSION_ALLOWED = [
  ...IMAGE_EXTENSIONS,
  ...PDF_EXTENSIONS,
  ...TEXT_EXTENSIONS,
  ...WORD_EXTENSIONS,
  ...EXCEL_EXTENSIONS,
  ...OPEN_OFFICE__EXTENSIONS,
];

export const FILE_EXTENSION_WITH_THUMBNAIL = [
  ...IMAGE_EXTENSIONS,
  ...PDF_EXTENSIONS,
];

export const MAPPED_MIME_TYPE: { [key: string]: string } = {
  ".jpeg": "image/jpeg",
  ".jpg": "image/jpeg",
  ".png": "image/png",
  ".pdf": "application/pdf",
  ".txt": "text/plain",
  ".doc": "application/msword",
  ".docx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".odt": "application/vnd.oasis.opendocument.text",
  ".ods": "application/vnd.oasis.opendocument.spreadsheet",
};
